/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import classnames from 'classnames';
import aloomaSdk from '../../aloomaSdk';
import { ALOOMA_ELEMENT_NAMES, ALOOMA_NOT_STANDARD_DATA, ALOOMA_PAGE_NAMES } from '../../consts/alooma';
import './UninstallForm.css';

const FEEDBACK_ID = 'feedback';

const UninstallForm = () => {
  const [sent, setSent] = useState(false);
  const [feedback, setFeedback] = useState('');

  const handleSubmit = async event => {
    try {
      event.preventDefault();

      const payload = {
        ...ALOOMA_NOT_STANDARD_DATA,
        element_name: ALOOMA_ELEMENT_NAMES.SUBMIT,
        page_name: ALOOMA_PAGE_NAMES.extension_uninstall,
        reason: feedback,
      };

      globalThis.alooma.track('click', payload);

      setSent(true);
    } catch (error) {
      console.error(error);
    }
  };

  aloomaSdk.usePageViewTracker();

  return (
    <form className="page__container" onSubmit={handleSubmit}>
      <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="logo" className="page__logo" />

      <h1 className="page__title">We’re sad to see you go</h1>

      <div className="page__feedback">
        <label
          htmlFor={FEEDBACK_ID}
          className={classnames({
            page__feedback__label: true,
            disabled: sent,
          })}
        >
          Let us know where we can improve
        </label>
        <textarea
          placeholder="Type here"
          className="page__feedback__textarea"
          id={FEEDBACK_ID}
          value={feedback}
          onChange={e => setFeedback(e.target.value)}
          disabled={sent}
        />
      </div>

      <button className="page__button" disabled={!feedback?.length || sent} type="submit">
        {sent ? 'Sent' : 'Send'}
        {sent && <img src={`${process.env.PUBLIC_URL}/checkmark.svg`} alt="Check icon" className="submitted-icon" />}
      </button>
    </form>
  );
};

export default UninstallForm;
